import { useEffect, useState } from "react";
import { Eye, EyeSlash, Warning } from "@phosphor-icons/react";
import { Input } from "./ui/input";

// Password field with a show/hide eye toggle and Caps Lock warning. `revealed` lets a parent force it visible.
export const PasswordInput = ({ revealed = false, className = "", onKeyDown, onKeyUp, onBlur, ...props }) => {
  const [show, setShow] = useState(revealed);
  const [caps, setCaps] = useState(false);
  useEffect(() => { setShow(revealed); }, [revealed]);
  const tid = props["data-testid"];
  const checkCaps = (e) => { if (e.getModifierState) setCaps(e.getModifierState("CapsLock")); };
  return (
    <div className={className}>
      <div className="relative">
        <Input {...props} type={show ? "text" : "password"} className="pr-10"
          onKeyDown={(e) => { checkCaps(e); onKeyDown?.(e); }}
          onKeyUp={(e) => { checkCaps(e); onKeyUp?.(e); }}
          onBlur={(e) => { setCaps(false); onBlur?.(e); }} />
        <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1}
          aria-label={show ? "Hide password" : "Show password"} title={show ? "Hide password" : "Show password"}
          className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground transition-colors"
          data-testid={tid ? `${tid}-toggle` : undefined}>
          {show ? <EyeSlash size={16} /> : <Eye size={16} />}
        </button>
      </div>
      {caps && (
        <p className="mt-1 flex items-center gap-1 text-xs text-amber-500" data-testid={tid ? `${tid}-capslock` : undefined}>
          <Warning size={12} weight="bold" /> Caps Lock is on
        </p>
      )}
    </div>
  );
};
